import React from 'react';
import { useIntl } from 'react-intl';
import ErrorPage from 'components/ErrorPages/ErrorPage';

function PersonalEmailErrorPage() {
  const intl = useIntl();

  return (
    <ErrorPage
      headerContent={
        <>
          {intl.formatMessage({
            id: 'auth0.errorPages.personalEmailPage.headerLine1',
          })}
        </>
      }
      subheaderContent={
        <>
          {intl.formatMessage({
            id: 'auth0.errorPages.personalEmailPage.subheader1',
          })}{' '}
          <a
            className="error-page__contact-support"
            href="https://cloud.incorta.com/support"
            target="_blank"
            rel="noopener noreferrer"
          >
            {intl.formatMessage({
              id: 'auth0.errorPages.personalEmailPage.subheader2',
            })}
          </a>
        </>
      }
    ></ErrorPage>
  );
}

export default PersonalEmailErrorPage;
